import { FC } from 'react';
import { useLocation } from 'react-router';
import { useCheckDevice } from '../../hooks/UseCheckDevice';
import DesktopSideNav from '../shared-layout/desktop/side-nav/DesktopSideNav';
import MobileSideNav from '../shared-layout/mobile/side-nav/MobileSideNav';

export const SideNav: FC = () => {
  const { isMobileDevice } = useCheckDevice();
  const location = useLocation();
  const path = location.pathname;

  return !isMobileDevice ? (
    <DesktopSideNav data-testid='desktop-side-nav' currentUrl={path} />
  ) : (
    <MobileSideNav data-testid='mobile-side-nav' currentUrl={path} />
  );
};
